// Whether a session takes its prompt and a question's answer through this
// Mac's runner while the server is offline (offline design §4, Poulpe-830):
// it runs on this Mac's runner, and that runner says its owner started it.
// A runner older than its writes says no `by_owner`, so nothing is local
// and nothing is said beyond "Needs the server".
import { useEffect, useState } from 'react'
import { localRunner, localSessions } from '../api/shellLocalReads'

/** True once this Mac's runner says `session` takes a write here; false online, elsewhere, or until it says so. */
export function useLocalWrites(session: { id: string; runner_id: string } | null | undefined, offline: boolean): boolean {
  const id = session?.id ?? null
  const local = offline && !!session && session.runner_id !== '' && session.runner_id === localRunner()
  const key = local ? id : null
  const [writable, setWritable] = useState<string | null>(null)
  useEffect(() => {
    if (!key) return
    let current = true
    void localSessions().then(sessions => {
      if (current) setWritable(sessions?.some(s => s.session === key && s.byOwner) ? key : null)
    })
    return () => {
      current = false
      setWritable(null)
    }
  }, [key])
  return key !== null && writable === key
}
